import React from 'react';

export const Mask = ({children, style}) => {
  return(
    <div className='fixed-mask' style={{...style}}>
      <div className='mask-panel' style={{ padding: 20 }}>
        {children}
      </div>
    </div>
  )
}